import { useMemo } from 'react';

// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { useColorScheme } from '@mui/material/styles';

// project imports
import AppBarStyled from './AppBarStyled';
import HeaderContent from './HeaderContent';
import IconButton from 'components/@extended/IconButton';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import { DRAWER_WIDTH, MINI_DRAWER_WIDTH } from 'config';
import useConfig from 'hooks/useConfig';

// assets
import MenuFoldOutlined from '@ant-design/icons/MenuFoldOutlined';
import MenuUnfoldOutlined from '@ant-design/icons/MenuUnfoldOutlined';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

export default function Header() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const { state } = useConfig();
  const { mode } = useColorScheme();

  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  // header content
  const headerContent = useMemo(() => <HeaderContent />, []);

  // common header
  const mainHeader = (
    <Toolbar sx={{ minHeight: { xs: 64, sm: 64 }, px: { xs: 1, sm: 2 }, gap: { xs: 0.5, sm: 1 } }}>
      <IconButton
        aria-label="open drawer"
        onClick={() => handlerDrawerOpen(!drawerOpen)}
        edge="start"
        color="inherit"
        sx={{
          ml: { xs: 0, lg: -2 },
          flexShrink: 0
        }}
      >
        {!drawerOpen ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
      </IconButton>
      {headerContent}
    </Toolbar>
  );

  const activeMode = mode || 'dark';
  const isGlass = activeMode === 'dark' && state.darkModeStyle === 'discord-glass';

  const headerStyle = activeMode === 'light' ? {
    bgcolor: 'background.paper',
    color: 'text.primary',
    borderBottom: '1px solid',
    borderBottomColor: 'divider',
    backgroundImage: 'none'
  } : (isGlass ? {
    bgcolor: 'rgba(10, 12, 18, 0.45)',
    color: 'text.primary',
    backdropFilter: 'blur(20px) saturate(130%)',
    borderBottom: '1px solid rgba(255, 255, 255, 0.08) !important',
    backgroundImage: 'none'
  } : {
    bgcolor: 'background.paper',
    color: 'text.primary',
    borderBottom: '1px solid',
    borderBottomColor: 'divider',
    backgroundImage: 'none'
  });

  // app-bar params
  const appBar = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    'data-color-scheme': activeMode,
    sx: {
      ...headerStyle,
      zIndex: 1200,
      width: { xs: '100%', lg: drawerOpen ? `calc(100% - ${DRAWER_WIDTH}px)` : `calc(100% - ${MINI_DRAWER_WIDTH}px)` },
      transition: 'none',
      willChange: 'initial'
    }
  };

  return (
    <>
      {!downLG ? (
        <AppBarStyled open={drawerOpen} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar {...appBar}>{mainHeader}</AppBar>
      )}
    </>
  );
}


